<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="{ 'active-dropzone': active }"
    class="dropzone position-relative"
  >
    <div class="mb-1">
      <i class="display-4 text-muted ri-upload-cloud-2-fill"></i>
    </div>

    <h5>فایل ها را اینجا رها کنید یا برای بارگذاری کلیک کنید.</h5>
    <label for="dropzoneFile" class="bg-light text-dark stretched-link"
      >بارگذاری</label
    >
    <input type="file" id="dropzoneFile" class="dropzoneFile btn btn-primary" />
  </div>
</template>

<script setup>
import { ref } from "vue"

const name = "dropzone"

const active = ref(false)

const toggleActive = () => {
  active.value = !active.value
}
</script>
